const initRdetailData = {
  
}


export function rdetailData(
  state = initRdetailData,
  action
) {
  switch (action.type) {
    case "RDETAIL_FETCH_DATA_SUCCESS":
      return action.dataRdetail;
    default:
      return state;
  }
}
